<template>
  <div class="faq-table">
    <div
      v-if="layout === 'table-last' && text"
      class="faq-table__text rte"
      v-html="text"
    />

    <csv-table
      v-if="csvUrl"
      :url="csvUrl"
      :alternate="alternate"
      :even-columns="evenColumns"
      :header-column="headerColumn"
      :header-row="headerRow"
      :sticky-first-column="stickyFirstColumn"
    />

    <div
      v-if="layout === 'table-first' && text"
      class="faq-table__text rte"
      v-html="text"
    />
  </div>
</template>

<script>
import CsvTable from '~async/csv-table/csv-table'
export default {
  name: 'FaqTable',

  components: {
    CsvTable,
  },

  props: {
    alternate: {
      type: Boolean,
      default: false,
    },
    csvUrl: {
      type: String,
      default: '',
    },
    evenColumns: {
      type: Boolean,
      default: false,
    },
    headerColumn: {
      type: Boolean,
      default: false,
    },
    headerRow: {
      type: Boolean,
      default: false,
    },
    stickyFirstColumn: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    layout: {
      type: String,
      default: 'table-first',
    },
  },
}
</script>

<style lang="scss">
@import './faq-table';
</style>